const spacesKeys = {
  spaces: ["spaces"],
  byAssociation: (ref) => [...spacesKeys.spaces, ref],
};

export default spacesKeys;
